import { joiResolver } from "@hookform/resolvers/joi";
import Joi from "joi";
import type React from "react";
import { FormProvider, type SubmitHandler, useForm } from "react-hook-form";
import { FormGroupLabelUI } from "../../../../components/FormGroupLabel";
import { InputUI } from "../../../../components/rhfs/Input";
import { Button } from "../../../../components/ui/button";
import type { ResetPassWordInput } from "../../../../hooks/authProvider/authProvider";

type ResetPassWordInputUIProps = {
  onResetPassWord: SubmitHandler<ResetPassWordInput>;
};

export const ResetPassWordInputUI: React.VFC<ResetPassWordInputUIProps> = ({
  onResetPassWord,
}) => {
  const schema = Joi.object({
    email: Joi.string().required().messages({
      "string.empty": "メールアドレスは必須項目です",
    }),
  });
  const methods = useForm<ResetPassWordInput>({
    resolver: joiResolver(schema),
  });
  return (
    <div className="w-5/6 mx-auto">
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onResetPassWord)}>
          <FormGroupLabelUI>メールアドレス</FormGroupLabelUI>
          <InputUI
            registerName="email"
            placeholder="メールアドレス"
            className="w-full"
            data-testid="reset-pass-word-input-email"
          />

          <div className="flex justify-center mt-12">
            <Button
              size="lg"
              type="submit"
              className="w-full"
              data-testid="reset-pass-word-input-submit"
            >
              パスワードを再設定
            </Button>
          </div>
        </form>
      </FormProvider>
    </div>
  );
};
